<p-toast position="top-right"></p-toast>
<div class="p-g booking-Slot-Responsive">
  <div class="p-g-12">
    <form #BookingSlotForm="ngForm">
      <div class="p-g-12">
        <p-toolbar>
          <div class="p-toolbar-group-left p-toolbar-tecfolk-fix">
            <!-- <button routerLink="booking-slot" pButton type="button" label="New" icon="pi pi-plus"></button> -->
            <button (click)="save(BookingSlotForm)" pButton *ngIf="mode == 'add'" type="button"
              [label]='setLabel("saveBtnLabel")' icon="pi pi-save" class="p-button-success"></button>&nbsp;
            <button (click)="update(BookingSlotForm)"  pButton *ngIf="mode == 'edit'"
              type="button" [label]='setLabel("updateBtnLabel")' icon="pi pi-save" class="p-button-success"></button>&nbsp;
          </div>
        </p-toolbar>
      </div>
      <p-tabView>
        <!-- <p-tabPanel header="Details"> -->
          <div class="card card-w-title">
            <div class="p-g-12">
              <form #BookingSlotForm="ngForm" class="bookingSlotForm">
                <div class="p-g-12" style="text-align: left">
                  <h3 class="first">{{setLabel("slotDetailsLabel")}}</h3>
                  <div class="p-g p-fluid">
                    <div class="p-g-12">
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                        <!-- pattern="[A-Za-z ]+" -->
                        <input type="text" pInputText [placeholder]='setLabel("searchBySlotNamePlaceholderLabel")' name="name" #name="ngModel"
                          [(ngModel)]="BookingSlot.name" required
                          [ngClass]="name.invalid && (name.dirty || name.touched) ? 'errorInput' : '' ">
                      </div>
                      <div *ngIf="name.invalid && (name.dirty || name.touched)">
                        <div *ngIf="name.errors.required" class="errorShow">
                          {{setLabel("nameRequiredErrorLabel")}}
                        </div>
                        <!-- <div *ngIf="name.errors.pattern" class="errorShow">
                          Only Characters are Allowed.
                        </div> -->
                      </div>
                    </div>
                    <h3 class="first">{{setLabel("filledSlotsLabel")}}</h3>
                    <div class="p-g-12">
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                        <input type="number" [placeholder]='setLabel("searchByFilledSlotPlaceholderLabel")' Filled Slot pInputText #filledSlots="ngModel"
                          name="filledSlots" [(ngModel)]="BookingSlot.filledSlots" required autocomplete="off" pattern="[0-9]+"
                          [ngClass]="filledSlots.invalid && (filledSlots.dirty || filledSlots.touched) ? 'errorInput' : '' ">
                      </div>
                      <div *ngIf="filledSlots.invalid && (filledSlots.dirty || filledSlots.touched)">
                        <div *ngIf="filledSlots.errors.required" class="errorShow">
                          {{setLabel("filledSlotsCorrectlyErrorLabel")}}
                        </div>
                        <div *ngIf="filledSlots.errors.pattern" class="errorShow">
                          {{setLabel("filledSlotsCorrectlyErrorLabel")}}
                        </div>
                      </div>
                    </div>
                    <!--<div class="p-g-12">
                      <p-calendar [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true" [(ngModel)]="BookingSlot.dateOfBirth" placeholder="Date Of Birth" name="dob"
                        [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
                      </p-calendar>
                    </div>
                    <h3 class="first">Joining Date</h3>
                    <div class="p-g-12">
                      <p-calendar [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true" [(ngModel)]="BookingSlot.date" [disabled]="true" placeholder="Joining Date" name="date"
                        [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
                      </p-calendar>
                    </div> -->
                    <!-- <div class="p-g-12">
                      <div class="p-g">
                        <h3 class="first">Gender</h3>
                        <div class="p-g-12">
                          <div class="p-g-6">
                            <p-radioButton name="group1" value="Male" label="Male" [(ngModel)]="BookingSlot.gender"
                              inputId="opt1">
                            </p-radioButton>
                          </div>
                          <div class="p-g-6">
                            <p-radioButton name="group1" value="Female" label="Female" [(ngModel)]="BookingSlot.gender"
                              inputId="opt2">
                            </p-radioButton>
                          </div>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
                <div class="p-g-12" style="text-align: left">
                <h3 class="first">{{setLabel("totalSlotsLabel")}}</h3>
               <div class="p-g-12">
                 <div class="p-inputgroup">
                   <span class="p-inputgroup-addon"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                   <input type="number" required pInputText
                     autocomplete="off"
                     [ngClass]="totalSlots.invalid && (totalSlots.dirty || totalSlots.touched) ? 'errorInput' : '' "
                     [placeholder]='setLabel("searchByTotalSlotPlaceholderLabel")' name="totalSlots" #totalSlots="ngModel" [(ngModel)]="BookingSlot.totalSlots">
                 </div>
                 <div *ngIf="totalSlots.invalid && (totalSlots.dirty || totalSlots.touched)">
                   <div *ngIf="totalSlots.errors.required" class="errorShow">
                     {{setLabel("slotsRequiredErrorLabel")}}
                   </div>
                 </div>
               </div>
               <br />
                 <h2 class="startTimeH2">Start Time Slot</h2>
                 <!-- <hr> -->
                 <div class="fromToMain p-g-12">

                  <div class="p-g-12 p-md-6">
                    <h3 class="h3">{{setLabel("from:Label")}}</h3>
                    <p-calendar name="startTime" [(ngModel)]="BookingSlot.startTime" [hourFormat]="12" required [timeOnly]="true"></p-calendar>
                  </div>
                  <div class="p-g-12 p-md-6">
                    <h3 class="h3">{{setLabel("to:Label")}}</h3>
                    <p-calendar name="endTime" [(ngModel)]="BookingSlot.endTime" required [hourFormat]="12" [timeOnly]="true"></p-calendar>
                  </div>
                 </div>

                  <!-- <h3 class="first">Contact Details</h3>
                  <div class="p-g p-fluid">
                    <div class="p-g-12">
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                        <input type="number" required pInputText
                          autocomplete="off"
                          [ngClass]="totalSlots.invalid && (totalSlots.dirty || totalSlots.touched) ? 'errorInput' : '' "
                          placeholder="Total Slots*" name="totalSlots" #totalSlots="ngModel" [(ngModel)]="BookingSlot.totalSlots">
                      </div>
                      <div *ngIf="totalSlots.invalid && (email.dirty || email.touched)">
                        <div *ngIf="totalSlots.errors.required" class="errorShow">
                          Total Slots is required.
                        </div>
                      </div>
                    </div>
                    <div class="p-g-12">
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-phone" aria-hidden="true"></i></span>
                        <input type="text" required pInputText #contact="ngModel" autocomplete="off" pattern="[0-9-]+"
                          [ngClass]="contact.invalid && (contact.dirty || contact.touched) ? 'errorInput' : '' "
                          placeholder="Contact*" name="contact" [(ngModel)]="BookingSlot.phone">
                      </div>
                      <div *ngIf="contact.invalid && (contact.dirty || contact.touched)">
                        <div *ngIf="contact.errors.required" class="errorShow">
                          Please Enter Contact Correctly.
                        </div>
                        <div *ngIf="contact.errors.pattern" class="errorShow">
                          Please Enter Contact Correctly.
                        </div>
                      </div>
                    </div>
                    <h3 class="first" *ngIf="mode=='add'">Visiting Fee</h3>
                    <div class="p-g-12" *ngIf="mode=='add'">
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                        <input type="number" placeholder="Visiting Fee PKR*" pInputText #visitingFee="ngModel"
                          name="visitingFee" [(ngModel)]="fund.pay" required autocomplete="off" pattern="[0-9]+"
                          [ngClass]="visitingFee.invalid && (visitingFee.dirty || visitingFee.touched) ? 'errorInput' : '' ">
                      </div>
                      <div *ngIf="visitingFee.invalid && (visitingFee.dirty || visitingFee.touched)">
                        <div *ngIf="visitingFee.errors.required" class="errorShow">
                          Please Enter Visiting Fee Correctly.
                        </div>
                        <div *ngIf="visitingFee.errors.pattern" class="errorShow">
                          Please Enter Visiting Fee Correctly.
                        </div>
                      </div>
                    </div>
                  </div>-->
                </div>
              </form>
            </div>
            <div style="clear: both;"></div>
          </div>
        <!-- </p-tabPanel> -->
        <!-- <p-tabPanel header="Fee Details" *ngIf="mode=='edit'">
          <div class="card card-w-title">
            <div class="p-g">
              <div class="p-g-12">
                <p-toolbar>
                  <div class="p-toolbar-group-left">
                    <button (click)="displayFund()" pButton type="button" label="Add Fee" icon="pi pi-plus"
                      class="p-button-success"></button>
                  </div>
                </p-toolbar>
                <p-table [value]="BookingSlot.feeDetails" [paginator]="true" [rows]="10" [loading]="loading">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Invoice</th>
                      <th>Fee</th>
                      <th>Status</th>
                      <th>Invoice Date</th>
                      <th>Actions</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-fee>
                    <tr>
                      <td>{{fee.invoice}}</td>
                      <td>{{fee.pay}}</td>
                      <td>{{fee.status}}</td>
                      <td>{{fee.date | date:'dd/MM/yyyy'}}</td>
                      <td>
                        <button pButton type="button" icon="fa fa-money" (click)="viewPrint(fee)"></button>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="footer">
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>Fee Total: {{feeTotal}}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td>
                        No records found
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </p-tabPanel> -->
      </p-tabView>
    </form>
  </div>
</div>
